const _listeners = {};
let lastUUID = -1;

const publish = (eventType, ...args) => {
    if(_listeners[eventType]) {
        Object.keys(_listeners[eventType]).forEach(keys => {
            _listeners[eventType][keys](...args);
        });
    }
};

const subscribe = (eventType, eventAction) => {
    const token = 'uuid_' + String(++lastUUID);
    if(_listeners[eventType]) {
        _listeners[eventType][token] = eventAction;
    }
    else {
        const actions = {};
        actions[token] = eventAction;
        _listeners[eventType] = actions;
    }
    return token;
};

const unsubscribe = (eventType, token) => {
    delete _listeners[eventType][token];
};

const PubSub = {
    publish,
    subscribe,
    unsubscribe
};

export default PubSub;
